import {
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  Td,
  Text,
  Tooltip,
  Tr
} from '@chakra-ui/react';
import {
  faBars,
  faPenToSquare,
  faTrash
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText, MenuItem } from '@morressier/alembic';
import { ITagCategoryList } from './ManageTagCategories';
import { useState } from 'react';
import CreateTagCategory from './CreateTagCategory';
import DeleteTagCategory from './DeleteTagCategory';
import { useWorkspace } from '../../SubmissionContexts/Users/userHook';

const NAME_COLUMN_WIDTH = '24%';
const DESCRIPTION_COLUMN_WIDTH = '58%';
const COLOR_COLUMN_WIDTH = '12%';
const ACTION_COLUMN_WIDTH = '6%';

const TagCategoryItem = ({ data }: { data: ITagCategoryList }) => {
  const {
    id,
    name: tagCategory,
    color: tagColor,
    description: tagDescription
  } = data;

  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { workspaceId } = useWorkspace();

  return (
    <>
      {openEditModal && (
        <CreateTagCategory
          isOpen={openEditModal}
          onClose={() => setOpenEditModal(false)}
          data={data}
        />
      )}
      {openDeleteModal && (
        <DeleteTagCategory
          categoryId={id}
          categoryName={tagCategory}
          onClose={() => setOpenDeleteModal(false)}
          workspaceId={workspaceId}
        />
      )}
      <Tr
        data-testId="tag-categories-table-row"
        _last={{ borderBottom: 'none' }}
        background="white"
      >
        <Td width={NAME_COLUMN_WIDTH}>
          <Tooltip
            hasArrow
            borderRadius={4}
            placement="top"
            label={tagCategory}
          >
            <Text noOfLines={1}>{tagCategory || 'N/A'}</Text>
          </Tooltip>
        </Td>

        <Td width={DESCRIPTION_COLUMN_WIDTH}>
          <Tooltip
            hasArrow
            borderRadius={4}
            placement="top"
            label={tagDescription || 'N/A'}
          >
            <Text noOfLines={1} maxW="100%">
              {tagDescription || 'N/A'}
            </Text>
          </Tooltip>
        </Td>
        <Td width={COLOR_COLUMN_WIDTH}>
          <Tooltip hasArrow borderRadius={4} placement="top" label={tagColor}>
            <Box
              w="30px"
              h="30px"
              bg={tagColor}
              border="1px solid"
              borderColor={'gray.300'}
              borderRadius="4px"
              shadow={'sm'}
            />
          </Tooltip>
        </Td>
        <Td width={ACTION_COLUMN_WIDTH}>
          <Flex justifyContent="flex-end" width="100%">
            <Menu aria-label="tag category actions menu">
              <MenuButton>
                <ButtonText>
                  <Flex gap={2} alignItems="center">
                    <FontAwesomeIcon size="lg" icon={faBars} />
                  </Flex>
                </ButtonText>
              </MenuButton>
              <MenuList>
                <MenuItem
                  ariaLabel="Edit Tag Category"
                  onClick={() => setOpenEditModal(true)}
                >
                  <Flex gap={2} alignItems="center">
                    <FontAwesomeIcon icon={faPenToSquare} />
                    <Text textStyle="context">Edit</Text>
                  </Flex>
                </MenuItem>

                <MenuItem
                  ariaLabel="Delete Tag Category"
                  onClick={() => setOpenDeleteModal(true)}
                >
                  <Flex
                    gap={2}
                    color="actionSecondaryCautionContent"
                    alignItems="center"
                  >
                    <FontAwesomeIcon icon={faTrash} />
                    <Text textStyle="context">Delete</Text>
                  </Flex>
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Td>
      </Tr>
    </>
  );
};

export default TagCategoryItem;
